// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"4cd80cfd","102":"5f8c23b6","168":"1f26bf92","185":"55ef9856","229":"bb0b0626","264":"c2171011","321":"6fdb9b7b","639":"e48e32e9","708":"331b8d80","890":"84077a46"}[chunkId] + ".chunk.js";
};